import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import Loading from '@core/components/loading/Loading.vue'

Vue.component('Loading', Loading)
Vue.component(FeatherIcon.name, FeatherIcon)
